var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPipeline01 = function SvgPipeline01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "pipeline-01_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pipeline-01_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26 11.038v1.983h-.907a2.429 2.429 0 0 1-2.426-2.426V7.05h-.275a.253.253 0 0 1-.179-.43.251.251 0 0 1 .178-.073h2.462a.253.253 0 0 1 .179.43.25.25 0 0 1-.178.073h-.223v3.524c0 .252.193.442.443.442h.924v.02h.001ZM18.6 17.2a.25.25 0 0 1-.25.25h-2.462a.252.252 0 0 1-.001-.502h.299V13.42a.435.435 0 0 0-.443-.443h-.905v-1.964h.905a2.429 2.429 0 0 1 2.426 2.426v3.51h.179c.139 0 .252.113.252.252Zm-5.35-3.62v-3.178c0-.675-.54-1.194-1.195-1.194a1.2 1.2 0 0 0-1.194 1.194v3.177a1.2 1.2 0 0 0 1.194 1.194 1.2 1.2 0 0 0 1.194-1.194Zm-2.935-.357v-2.461a.252.252 0 1 0-.503 0v2.461a.252.252 0 1 0 .503 0Zm3.98-2.464v2.462a.252.252 0 1 1-.503 0V10.76a.252.252 0 1 1 .502 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pipeline-01_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgPipeline01 as ReactComponent };